import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "../../../../../../shadcn/components/ui/button";
import {
  bidderInitiateDigioDocumentRequest,
  fetchFuzzyMatchDetails,
  getBidderByUuid,
  getBidderInitiateDigioDocumentRequestStatus,
  updateBidderForEvent,
} from "services/bidder";
import JBNameMismatchModal from "./JBNameMismatchModal";
import KycStatusNotice from "../KycStatusNotice";
import SwitchToOfflineKycModal from "../../SwitchToOfflineKycModal";
import ErrorModal from "../IndividualBidders/ErrorModal";
import KYCRequestRedirectNotificationModal from "../IndividualBidders/KYCRequestRedirectNotificationModal";
import KYCRejectedNotice from "../KYCRejectedNotice";
interface JBKycDocumentsComponentProps {
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  bidderUuid: any;
  init: any;
  bidder: any;
}
export default function JBKycDocumentsComponent({
  stepsTitles,
  activeStep,
  setActiveStep,
  bidderUuid,
  init,
  bidder,
}: JBKycDocumentsComponentProps) {
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const [isKYCPending, setIsKYCPending] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState<any>(false);
  const [openNameMismatchModel, setOpenNameMismatchModel] = useState(false);
  const [nameMismatchObject, setNameMismatchObject] = useState<any>({
    type: "",
    profileName: "test",
    kycName: "test2",
  });
  const [switchToOfflineModalOpen, setSwitchToOfflineModalOpen] =
    useState(false);
  const [switchingToOffline, setSwitchingToOffline] = useState(false);

  type KycRejectionState = {
    isRejected: boolean;
    reason: string;
  };

  const initialKycRejectionState: KycRejectionState = {
    isRejected: false,
    reason: "",
  };

  const [kycRejection, setKycRejection] = useState<KycRejectionState>(
    initialKycRejectionState,
  );
  const [errorModel, setErrorModel] = useState(false);
  const [redirectNotificationModelOpen, setRedirectNotificationModelOpen] =
    useState(false);
  const handleDigioDocumentRequestRetry = async () => {
    await updateBidderForEvent({
      uuid: bidderUuid,
      kyc_data: {},
    });
    // setActiveStep(activeStep + 1);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    await init();
    setOpenNameMismatchModel(false);
  };

  const getKycNamesFromDigio = (digioResponse: any) => {
    const actions = digioResponse?.status_response?.actions || [];
    console.log("actions: ", actions);

    // Aadhaar details
    const digilockerAadhaarDetails =
      actions.find((action: any) => action.type === "digilocker")?.details
        ?.aadhaar || null;
    console.log("digilockerAadhaarDetails: ", digilockerAadhaarDetails);

    const nonDigilockerAadhaarDetails =
      actions.find(
        (action: any) =>
          action?.type === "image" && action?.action_ref === "id_proof-3",
      )?.ocr_result || null;
    console.log("nonDigilockerAadhaarDetails: ", nonDigilockerAadhaarDetails);

    // PAN details
    const digilockerPanDetails =
      actions.find((action: any) => action.type === "digilocker")?.details
        ?.pan || null;

    console.log("digilockerPanDetails: ", digilockerPanDetails);

    const nonDigilockerPanDetails =
      actions.find(
        (action: any) =>
          action?.type === "image" &&
          ["id_proof-1", "id_proof-2"].includes(action?.action_ref),
      )?.ocr_result || null;
    console.log("nonDigilockerPanDetails: ", nonDigilockerPanDetails);

    return {
      nameFromAadhaar:
        digilockerAadhaarDetails?.name ||
        nonDigilockerAadhaarDetails?.name ||
        "",
      nameFromPan:
        digilockerPanDetails?.name || nonDigilockerPanDetails?.name || "",
    };
  };

  const initialDataFetch = async (bidderUuid: any) => {
    setCheckingStatus(true);
    if (bidderUuid) {
      try {
        const data: any = await getBidderByUuid(bidderUuid);
        console.log("bidder data in initialDataFetch1:", data);
        // setBidder(data);
        // setFinalApprovalStatus(data.status || "pending");
        if (data?.kyc_data?.status === "rejected") {
          setKycRejection({
            isRejected: true,
            reason: data?.kyc_data?.reject_remarks || "Rejected",
          });
        } else {
          setKycRejection(initialKycRejectionState);
        }
        if (data?.kyc_data?.digio_request_details?.digio_request_id) {
          console.log("Fetching KYC status from Digio...");
          // const kycReport = await postDataWithHeadersStatus();
          const payload = {
            kyc_request_id:
              data?.kyc_data?.digio_request_details?.digio_request_id,
            save_kyc_data_after_name_verification: true,
            eligible_bidders_uuid: bidderUuid,
          };
          const kycReport: any =
            await getBidderInitiateDigioDocumentRequestStatus(payload);
          console.log("kycReport:=====>>>>>>> ", kycReport);
          if (
            data?.kyc_data?.digio_request_details?.digio_request_id &&
            (kycReport?.status === "approved" ||
              kycReport?.status === "approval_pending")
          ) {
            let fuzzyMatchPayload: any = {
              context: "name",
              source_text: data?.meta?.name,
            };
            const kycNamesFronDigio = getKycNamesFromDigio(kycReport);
            console.log("kycNamesFronDigio: ", kycNamesFronDigio);
            fuzzyMatchPayload["target_text"] =
              kycNamesFronDigio.nameFromAadhaar;
            const res2: any = await fetchFuzzyMatchDetails(fuzzyMatchPayload);
            console.log("res2: ", res2);
            if (!res2?.matched) {
              setNameMismatchObject({
                profileName: fuzzyMatchPayload["source_text"],
                kycName: fuzzyMatchPayload["target_text"],
                type: "Aadhaar",
              });
              setOpenNameMismatchModel(true);
              setCheckingStatus(false);
              return;
            }
            fuzzyMatchPayload["target_text"] = kycNamesFronDigio.nameFromPan;
            const res3: any = await fetchFuzzyMatchDetails(fuzzyMatchPayload);
            console.log("res3: ", res3);
            if (!res3?.matched) {
              setNameMismatchObject({
                profileName: fuzzyMatchPayload["source_text"],
                kycName: fuzzyMatchPayload["target_text"],
                type: "Pan",
              });
              setOpenNameMismatchModel(true);
              setCheckingStatus(false);
              return;
            }
            // save kyc data here only
            const kycUpdatedData = {
              ...data?.kyc_data,
              digio_request_status: kycReport?.status,
              digio_response: kycReport,
              verification_status: "verified",
            };
            kycUpdatedData["status"] = "completed";
            await updateBidderForEvent({
              uuid: bidderUuid,
              meta: {
                ...data?.meta,
                steps_status: {
                  ...data?.meta?.steps_status,
                  online_kyc: "completed",
                },
              },
              kyc_data: kycUpdatedData,
              verification_step: "online_kyc",
            });
            const payloadForDataSave = {
              kyc_request_id:
                data?.kyc_data?.digio_request_details?.digio_request_id,
              save_kyc_data_after_name_verification: true,
              eligible_bidder_uuid: bidderUuid,
            };
            try {
              if (data?.kyc_data?.is_kyc_file_persisted !== true)
                await getBidderInitiateDigioDocumentRequestStatus(
                  payloadForDataSave,
                );
            } catch (error) {
              console.log("error: ", error);
            }
            setActiveStep(activeStep + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            await init();
            return;
          } else if (
            data?.kyc_data?.digio_request_details?.digio_request_id &&
            kycReport.status !== "approved"
          ) {
            setIsKYCPending(true);
          } else {
            console.log("KYC Not started");
          }
        }
      } catch (error) {
        // setErrorModel(true);
        console.log("error: ", error);
      }
    }
    setCheckingStatus(false);
  };
  useEffect(() => {
    initialDataFetch(bidderUuid);
  }, [bidderUuid]);

  useEffect(() => {
    const scriptId = "digio-sdk-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://app.digio.in/sdk/v11/digio.js";
      script.async = true;

      document.body.appendChild(script);
      console.log("SCRIPT__INJECTED");
      return () => {
        const existingScript = document.getElementById(scriptId);
        if (existingScript) {
          console.log("called");
          document.body.removeChild(existingScript);
        }
      };
    }
  }, [checkingStatus, isKYCPending]);
  const handleDigioDocumentRequest = async () => {
    try {
      const res: any = await bidderInitiateDigioDocumentRequest({
        bidder_onboarding_uuid: onboardingData?.uuid,
        eligible_bidders_uuid: bidderUuid,
      });
      const digioEnvironment = process?.env?.NEXT_PUBLIC_DIGIO_ENVIRONMENT;
      var options = {
        environment: digioEnvironment,
        callback: async function (response: any) {
          if (response.hasOwnProperty("error_code")) {
            // await alertAdminOnKYCIncomplete({
            //   bidder_onboarding_uuid: onboardingData.uuid,
            //   eligible_bidders_uuid: bidderUuid,
            // });
          }
          // console.log("response---------->>>>2", response);
          // await init(bidderUuid);
        },
        logo: process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
          ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/24534319-e399-47f9-ad4c-f98d5d9bbbb3`
          : `${process.env.NEXT_PUBLIC_IMAGIX_URL}/fa4a3024-6d97-488b-88e0-a6f5d802b2ba`,
        is_redirection_approach: true,
        is_iframe: false,
        redirect_url: `${window.location.origin}/kyc/${bidderUuid}`,
        theme: {
          primaryColor: "#FF752C",
          secondaryColor: "#262626",
        },
      };
      // @ts-ignore
      var digio = new Digio(options);
      digio.init();
      const element: any = document.querySelector('[id^="wrapperdigio-ifm-"]');
      element?.classList?.add("custom-digio-style");
      digio.submit(res.id, res.customer_identifier, res?.access_token?.id);
    } catch (error) {
      console.log("error: ", error);
      setErrorModel(true);
    }
  };
  const handleSwitchToOffline = async () => {
    if (switchingToOffline) return;

    setSwitchingToOffline(true);
    setSwitchToOfflineModalOpen(false);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: "offline",
        },
        kyc_data: {},
      });
      for (let i = 0; i < data?.bidder_relations.length; i++) {
        const relation = data?.bidder_relations[i];
        if (relation.type === "viewer") {
          const viewerData: any = await getBidderByUuid(relation.bidder_uuid);
          await updateBidderForEvent({
            uuid: relation.bidder_uuid,
            meta: {
              ...viewerData.meta,
              bid_application_flow_mode: "offline",
            },
            kyc_data: {},
          });
        }
      }
      // Reload the page to show offline KYC flow
      window.location.reload();
    } catch (error) {
      console.log("error switching to offline KYC: ", error);
      setSwitchingToOffline(false);
      setErrorModel(true);
    }
  };
  const SwitchToOfflineKYCNotification = () => {
    return (
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-md mt-4">
        <div className="flex items-start sm:items-center space-x-3 flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 sm:mt-0"
          >
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
            />
          </svg>
          <div className="flex-1">
            <p className="text-blue-800 text-sm font-medium">
              Facing issues with Online KYC?
            </p>
            <p className="text-blue-700 text-xs mt-1">
              You can switch to Offline KYC mode by uploading your documents
              manually. Once done, fill out the auction participation form and
              submit it to the bank to complete your participation.
            </p>
          </div>
        </div>
        <Button
          onClick={() => setSwitchToOfflineModalOpen(true)}
          disabled={switchingToOffline}
          variant="outline"
          className="border-brand-headingBlue text-brand-headingBlue text-xs"
        >
          {switchingToOffline ? "Switching..." : "Switch to Offline Mode"}
        </Button>
      </div>
    );
  };
  const isJointIndividualOfflineFlowEnabled =
    process.env.NEXT_PUBLIC_ENABLE_OFFLINE_JOINT_INDIVIDUALS_KYC === "true";

  return (
    <div className="py-4">
      {!checkingStatus && kycRejection.isRejected && (
        <KYCRejectedNotice
          reason={kycRejection.reason}
          onRetry={handleDigioDocumentRequestRetry}
          loading={checkingStatus}
          showRetryButton={false}
        />
      )}
      {checkingStatus && (
        <KycStatusNotice
          variant="info"
          message="Checking your auction participation application status. Please wait..."
        />
      )}
      {!checkingStatus && isKYCPending && (
        <KycStatusNotice
          variant="warning"
          message="Your auction participation step process is incomplete. Please complete all the required steps to proceed."
        />
      )}
      {isJointIndividualOfflineFlowEnabled && (
        <SwitchToOfflineKYCNotification />
      )}
      <h4 className="font-bold text-lg font-openSans mt-2">
        {stepsTitles?.[activeStep]?.label}
      </h4>
      <div className="pb-4 bg-white rounded-lg">
        <p className="text-sm text-brand-textBlack leading-relaxed">
          Please note that your profile name is{" "}
          <strong className="text-brand-orange">{onboardingData?.name}</strong>,
          and it must match the name on your official documents. If the document
          name does not match your profile name, your participation application
          will be rejected.
        </p>
        <div className="p-4">
          <p className="text-sm text-gray-600 mt-2">
            Please have the following details ready before starting the
            participation application process:
          </p>
          <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
            <li>Aadhaar and PAN linked to Digilocker</li>
            <li>Or, PAN Card</li>
            <li>Aadhaar Card</li>
            <li>Aadhaar linked to your mobile number</li>
          </ul>

          <div className="flex justify-center lg:justify-start mt-12">
            <Button
              // disabled={
              //   checkingStatus ||
              //   waitForApproval ||
              //   finalApprovalStatus === "verified" ||
              //   finalApprovalStatus === "rejected"
              // }
              onClick={async () => {
                setRedirectNotificationModelOpen(true);
              }}
              className="w-full max-w-[400px] mid:w-[400px]"
            >
              Start Your KYC
            </Button>
          </div>
        </div>
      </div>
      {!checkingStatus && (
        <JBNameMismatchModal
          open={openNameMismatchModel}
          mismatchType={nameMismatchObject.type}
          setOpen={setOpenNameMismatchModel}
          profileName={nameMismatchObject.profileName}
          kycName={nameMismatchObject.kycName}
          handleRetryKycRequest={handleDigioDocumentRequestRetry}
          handleOfflineModeSwitch={handleSwitchToOffline}
        />
      )}
      {switchToOfflineModalOpen && (
        <SwitchToOfflineKycModal
          open={switchToOfflineModalOpen}
          setOpen={setSwitchToOfflineModalOpen}
          handleConfirm={handleSwitchToOffline}
          isSecondaryBidder={true}
        />
      )}
      {errorModel && (
        <ErrorModal open={errorModel} onClose={() => setErrorModel(false)} />
      )}
      {redirectNotificationModelOpen && (
        <KYCRequestRedirectNotificationModal
          open={redirectNotificationModelOpen}
          onClose={() => setRedirectNotificationModelOpen(false)}
          onConfirm={handleDigioDocumentRequest}
        />
      )}
    </div>
  );
}
